export default __webpack_public_path__ + "static/media/Maria-Cayanan.c9bf4fcc.jpg";